import React from "react";
import { TextInput } from "./text_input";
import { Text } from "./text";

interface TextFormFieldProps {
  autoFocus?: boolean;
  label?: string;
  name: string;
  value: string;
  placeholder?: string;
  error?: string | false;
  onChange: (value: string) => void;
  onSubmitEditing?: () => void;
  onFocusOut?: () => void;
  direction?: "ltr" | "rtl";
}

export function TextFormField(props: TextFormFieldProps) {
  const {
    label,
    autoFocus,
    error,
    name,
    placeholder,
    value,
    onChange,
    onSubmitEditing,
    onFocusOut,
    direction,
  } = props;

  return (
    <div className="text-form-field">
      {label && (
        <label htmlFor={name}>
          <Text color="muted">{label}</Text>
        </label>
      )}
      <TextInput
        autoFocus={autoFocus}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onSubmitEditing={onSubmitEditing}
        onFocusOut={onFocusOut}
        invalid={!!error}
        direction={direction}
      />
      <div className="text-form-field-error">
        <Text color="error">{error}</Text>
      </div>
    </div>
  );
}
